import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApprovalService } from 'src/app/Services/approval.service';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { Approval } from 'src/app/Models/Approval';
import { CustomerSiteContract } from 'src/app/Models/CustomerSiteContract';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CustomerSiteContractAddOnCharge } from 'src/app/Models/CustomerSiteContractAddOnCharge';
import { CustomerSiteSKUList } from 'src/app/Models/CustomerSiteSKUList';
import { CustomerSiteVendor } from 'src/app/Models/CustomerSiteVendor';
import { CustomerSiteTradeReference } from 'src/app/Models/CustomerSiteTradeReference';
import { CustomerSiteOperation } from 'src/app/Models/ServiceLocationAndOperation';
import { CustomerSite } from 'src/app/Models/CustomerSite';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceLocationAndOperationService } from 'src/app/Services/service-location-and-operation.service';
import { ExportUtility } from 'src/assets/js/export-utility';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { CustomerinformationService } from 'src/app/Services/customerinformation.service';
import { ExistingvendorService } from 'src/app/Services/existingvendor.service';
import { TradereferenceService } from 'src/app/Services/tradereference.service';
import { KeyPress } from 'src/assets/js/KeyPress';
import { CustomerSUKService } from 'src/app/Services/customer-suk.service';
import { APIService } from 'src/app/Services/api.service';
import { MapsAPILoader } from '@agm/core';
import { CustomerSiteCostAndContractService } from 'src/app/Services/customer-site-cost-and-contract.service';
import { PrequoteApprovalService } from 'src/app/Services/prequote-approval.service';
import { vContract, vcusEmailID, vCustomersite, vServiceLocations, vSUK } from 'src/app/Validators/validation';
import { FileUpload } from 'primeng/fileupload';
import { CustomerSiteAddress } from 'src/app/Models/CustomersiteAddress';
import { CustomerSiteContact } from 'src/app/Models/Customersitecontact';
import { usererrors } from 'src/app/errors/usererrors';
import * as XLSX from 'xlsx';
import { CustomerSiteContractRegion } from 'src/app/Models/CustomerSiteContractRegion';
import { CustomerSiteContractArticle } from 'src/app/Models/CustomerSiteContractArticle';
import { CustomerSiteContractSlab } from 'src/app/Models/CustomerSiteContractSlab';
import { CustomerSiteContractTwoD } from 'src/app/Models/CustomerSiteContractTwoD';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-viewprequote',
  templateUrl: './viewprequote.component.html',
  styleUrls: ['./viewprequote.component.css']
})
export class ViewprequoteComponent implements OnInit {
  public _Url = environment.Url;
  _ApprovalListGrid: any[];
  _TempApprovalListGrid: any[];
  displayViewApproval: boolean = false;
  ViewApprovalURL: any;
  _IsProgressSpinner: boolean = false;

  //////////////-------------Customer Informations-----------////////////////
  displaySuccessMSG: boolean = false;
  _CustomerSiteform: FormGroup;
  _CustomerAddressPickupform: FormGroup;
  _CustomerAddressBillingform: FormGroup;
  _CustomerContactPickform: FormGroup;
  _CustomerContactInvoiceform: FormGroup;
  _CustomerContactOutgoingform: FormGroup;
  _CustomerSite: CustomerSite;
  _Tempform: FormGroup
  _TempformforTab: FormGroup
  CustomersListGrid: any[];
  selectedtab: number = 0;
  selectedtab1: number = 0;
  Contactselectedtab: number = 0
  displayBasic: boolean;
  _CompanyType: any[]
  _CreditType: any[]
  _AccquiredAgent: any[]
  _Agent: any[]
  _ProductType: any[]
  _BillingTo: any[]
  _AddressType: any[]
  _ContactAddressType: any[]
  _FloorType: any[]
  _Country: any[]
  _State: any[]
  _Region: any[]
  _District: any[]
  _Validation: any[]
  _GSTStatus: any[]
  ContactList: any
  Addresslist: any
  _GSTStatus_: any[]
  _Basedon: any[]
  Temp_Basedon: any[]
  _CustomerList: any[]
  _PincodeLocation: any[]
  pincodelocation: any[]
  pincodelocation1: any[]
  _PincodeLocation1: any[]
  disablePinLocation: boolean = true
  disablePinLocation1: boolean = true
  _LastAddedDocumentinCustomer: File
  CusomerFile: File[] = [];
  imageselect: string = ""
  _LastAddedGSTDocumentinCustomer: File
  _TempLastAddedGSTDocumentinCustomer: File
  CusomerGSTFile: File[] = [];
  GSTimageselect: string
  _SelectedCreditType: any[] = []
  CreditTypeCode: any
  CustomerCode: string
  CreditTypeName: string
  ExistCustomerCI: any[]

  CustomersiteCode: string
  _CustomerSiteCode
  _CustomerDetail: any
  _CustomerDetailTemp: any
  creditCode: any
  _CreditTypeCode: any
  _CreditTypeCode_: string[] = [];
  addressid: number
  addressid1: number
  contactid: number
  // contactid1: number
  // contactid2: number
  _submitted: boolean = false;
  quotestatusdisabled: boolean = true;
  // imageselect:any;
  GstValidationStatusCode: string
  validationStatusCode: string
  displayMap: boolean = false




  ExistCustomer: any[]
  selectedtabquote: number = 0
  // selectedtab: number = 0;
  // selectedtab1: number = 0;
  // selectedtab2: number = 0;
  // Contactselectedtab: number = 0;
  // ContactList:any[];
  transporter: string
  ManageCustomersList: any[]
  _BillingCycle: any[]
  id: any
  _CustomerType: any[]
  _QuoteStatus: any[]
  _Status: any[]
  hideStatus: boolean = true
  // CustomersListGrid:any[];
  // displayBasic: boolean;

  // _FloorType:any[]
  _Transporter: any[]

  _TempServiceLocationsCode: any
  _TempServiceLocations: any
  _TempSLPincodeLocation: any[]
  TempSLpincodelocation: any[]

  // CustomersListGrid:any[];
  SpecialDeliveryList: any[] = [];
  TATDetails: any[] = [];
  // selectedtab: number = 0;
  // displayBasic: boolean;
  _ServiceLocation: any[]
  _Tier: any[]
  _Requirments: any[]
  _SpecialDelivery: any[]
  // _FloorType:any[];
  // _State:any[]
  // _District:any[]
  _TatBased: any[]
  _Location: any[]


  agentListGrid: any[]
  VolumeList: any[]

  _Uom: any[]
  _Hub: any[]
  // _Basedon:any[]
  willDownload



  GeneralRateList: any[]
  // _State: any[]
  _OdaList: any
  _FlatOdaList: any
  // id: any
  idflat: any
  HideOpenTYpe: boolean = true
  HideFlatTYpe: boolean = true
  HideArticleODA: boolean = true
  HideTonnageODA: boolean = true
  HideServiceable: boolean = true
  HideTranscationTYpe: boolean = true

  _ServiceOpt: CustomerSiteOperation;



  contacttypeid: any[] = []
  // HideGeneralRate: boolean = true
  // HideArticleBased: boolean = true
  // HideRegionLevel: boolean = true
  // HideSlab: boolean = true
  // Hide2DRate: boolean = true



  //Trade Referance
  outsideCompanyList: CustomerSiteTradeReference[] = [];
  WithinCompanyList: CustomerSiteTradeReference[] = [];

  TempWithinCompanyList: CustomerSiteTradeReference[] = []
  TempoutsideCompanyList: CustomerSiteTradeReference[] = []

  EditTempWithinCompanyList: CustomerSiteTradeReference[] = []
  EditTempoutsideCompanyList: CustomerSiteTradeReference[] = []

  CompanyList: any[] = []
  TempCompanyList: any[] = []
  // displayBasic: boolean;
  // _Status:any[]

  // SpecialDeliveryList: any[]
  // selectedtab: number = 0;
  // displayBasic: boolean;
  OtherChargesList: any[]
  DoorCollectionList: any[]
  _WaybillType: any[]
  // _GSTStatus:any[]


  // _CustomerList: any[]
  // _PincodeLocation: any[]
  // pincodelocation: any[]
  // pincodelocation1: any[]
  // _PincodeLocation1: any[]
  // disablePinLocation: boolean = true
  // disablePinLocation1: boolean = true
  // _LastAddedDocument: File;
  // imageselect:any
  typeid: any
  _ContractType: any

  // _ContactAddressType:any[]
  // _Validation:any[]
  _Basedon1: any[]
  _TempformAD: FormGroup
  _ServiceLocationAndOperation_Form: FormGroup
  _ServiceLocationAndOperation_SpecialDelivery_Form: FormGroup
  _ServiceLocationAndOperation_TATDetails_Form: FormGroup
  _TATListTemp: any[]
  selectedFiles: FileList;
  currentFile: File;
  arrayBuffer: any
  VolumeReferList: any[]
  //SpecialDeliveryList:any[]
  TATselectedFiles: FileList;
  TATcurrentFile: File;
  addressRowIndex: number = -1;


  //Existing vendor
  CustomerVendorlist: any

  ExistingVendorList: CustomerSiteVendor[] = []
  TempExistingVendorList: CustomerSiteVendor[] = []
  ExistingVendorListTemp: CustomerSiteVendor[] = []
  _ExistingVendordetails: CustomerSiteVendor[]

  hidecustomer: boolean = true

  hidd_SpecialDelivery: boolean = true
  hidd_TATDetails: boolean = true
  hidd_TATInternalDetails: boolean = true


  //////////////////---------SL and SKU ---------/////////////////////

  _TempTierCode: any
  _TempTierName: any
  _TempPODCode: any

  SUKList: any[] = [];
  SUKVolumeDistrubutionList: any[] = [];
  ExistCustomerSL: any[]
  ExistCustomerSUK: any[]
  _Basedon_: any[]
  _BasedonSKU: any
  _SUK_Form: FormGroup
  _SUK_VolumeDistrubution_Form: FormGroup
  _selectedDocuments: File[] = [];
  selectedFilesInSKU: FileList;
  documentimage: SafeUrl;
  currentFileInSKU: File;
  _SLsubmitted: boolean = false
  _SLSpecialDeliverysubmitted: boolean = false
  _SLTATsubmitted: boolean = false
  _SUKsubmitted: boolean = false
  _SUKVolumeDistrubutionsubmitted: boolean = false
  HideUnReg: boolean = true
  HideAadhar: boolean = true
  _selectedServiceLocation: string[] = [];
  _selectedtier: string[] = [];
  _selectedPODReq: string[] = [];
  _SLFloorType: any[]
  _CustomerSKUList: CustomerSiteSKUList;
  _ODALocations: any[]
  _RateType_: any[]
  _CustomerLR: any[]
  _Invoice: any[]
  _ReturnBooking: any[]


  latitude: number = 0;
  longitude: number = 0;
  searchControl: FormControl;
  zoom: number = 1;
  QuantityPer: any = 0
  tempQuantity: any
  volumeQuantity: any = 0
  tempQuantitypercentage: any

  /////////////////////---------------Cost and Contract --------------////////////////////////////
  //---------------- Region Level -------------------//
  _BillingBranch: any[];
  _InclusiveExclusive: any[];
  _ToBranch: any[];
  _ArticleName: any[];
  _RateType: any[];
  _DCRateType: any[];
  _DDRateType: any[];
  _ArticleChargeCode: any[];
  _AddonCharges: any[];
  displayACRateType: boolean;
  displayDCRate: boolean;
  displayDCRateKG: boolean;
  displayDDRate: boolean;
  displayDDRateKG: boolean;
  displayACRate: boolean;
  displayACRateKG: boolean;
  _RegionLevelForm: FormGroup
  _CostingContract: FormGroup
  _FromDCPiece: string;
  _ToDCPiece: string;
  _RateDCPiece: string;
  _FromDCKG: string;
  _ToDCKG: string;
  _RateDCKG: string;
  _FromDDPiece: string;
  _ToDDPiece: string;
  _RateDDPiece: string;
  _FromDDKG: string;
  _ToDDKG: string;
  _RateDDKG: string;
  _FromACPiece: string;
  _ToACPiece: string;
  _RateACPiece: string;
  _FromACKG: string;
  _ToACKG: string;
  _RateACKG: string;
  _DCPiece: any[] = [];
  _DCKG: any[] = [];
  _DDPiece: any[] = [];
  _DDKG: any[] = [];
  _ACPiece: any[] = [];
  _ACKG: any[] = [];
  _RegionList: any[] = [];
  _updateRowRegion: boolean = true;
  _addRowRegion: boolean = false;
  _RegionIndex: any = null;
  _RegionLevelFormsubmitted: boolean = false
  _SlabType: any[];

  //---------------- Article Based -------------------//

  displayACRateTypeAB: boolean;
  displayDCRateAB: boolean;
  displayDCRateKGAB: boolean;
  displayDDRateAB: boolean;
  displayDDRateKGAB: boolean;
  displayACRateAB: boolean;
  displayACRateKGAB: boolean;
  _ArticleBasedForm: FormGroup
  _FromDCPieceAB: string;
  _ToDCPieceAB: string;
  _RateDCPieceAB: string;
  _FromDCKGAB: string;
  _ToDCKGAB: string;
  _RateDCKGAB: string;
  _FromDDPieceAB: string;
  _ToDDPieceAB: string;
  _RateDDPieceAB: string;
  _FromDDKGAB: string;
  _ToDDKGAB: string;
  _RateDDKGAB: string;
  _FromACPieceAB: string;
  _ToACPieceAB: string;
  _RateACPieceAB: string;
  _FromACKGAB: string;
  _ToACKGAB: string;
  _RateACKGAB: string;
  _DCPieceAB: any[] = [];
  _DCKGAB: any[] = [];
  _DDPieceAB: any[] = [];
  _DDKGAB: any[] = [];
  _ACPieceAB: any[] = [];
  _ACKGAB: any[] = [];
  _ArticleBasedList: any[] = [];
  _updateRowArticleBased: boolean = true;
  _addRowArticleBased: boolean = false;
  _ArticleBasedIndex: any = null;
  _ArticleBasedFormsubmitted: boolean = false


  //---------------- Slab -------------------//
  displaySlab: boolean;
  displayKGSlab: boolean;
  displayACRateTypeSlab: boolean;
  displayDCRateSlab: boolean;
  displayDCRateKGSlab: boolean;
  displayDDRateSlab: boolean;
  displayDDRateKGSlab: boolean;
  displayACRateSlab: boolean;
  displayACRateKGSlab: boolean;
  _SlabForm: FormGroup
  _FromPieceSlab: string;
  _ToPieceSlab: string;
  _RatePieceSlab: string;
  _FromKGSlab: string;
  _ToKGSlab: string;
  _RateKGSlab: string;
  _FromDCPieceSlab: string;
  _ToDCPieceSlab: string;
  _RateDCPieceSlab: string;
  _FromDCKGSlab: string;
  _ToDCKGSlab: string;
  _RateDCKGSlab: string;
  _FromDDPieceSlab: string;
  _ToDDPieceSlab: string;
  _RateDDPieceSlab: string;
  _FromDDKGSlab: string;
  _ToDDKGSlab: string;
  _RateDDKGSlab: string;
  _FromACPieceSlab: string;
  _ToACPieceSlab: string;
  _RateACPieceSlab: string;
  _FromACKGSlab: string;
  _ToACKGSlab: string;
  _RateACKGSlab: string;
  _PieceSlab: any[] = [];
  _KGSlab: any[] = [];
  _DCPieceSlab: any[] = [];
  _DCKGSlab: any[] = [];
  _DDPieceSlab: any[] = [];
  _DDKGSlab: any[] = [];
  _ACPieceSlab: any[] = [];
  _ACKGSlab: any[] = [];
  _SlabFormList: any[] = [];
  _updateRowSlab: boolean = true;
  _addRowSlab: boolean = false;
  _SlabIndex: any = null;
  _SlabFormsubmitted: boolean = false



  //---------------- 2D -------------------//
  display2D: boolean;
  displayKG2D: boolean;
  displayACRateType2D: boolean;
  displayDCRate2D: boolean;
  displayDCRateKG2D: boolean;
  displayDDRate2D: boolean;
  displayDDRateKG2D: boolean;
  displayACRate2D: boolean;
  displayACRateKG2D: boolean;
  _2DForm: FormGroup
  _FromPiece2D: string;
  _ToPiece2D: string;
  _RatePiece2D: string;
  _FromKG2D: string;
  _ToKG2D: string;
  _RateKG2D: string;
  _FromDCPiece2D: string;
  _ToDCPiece2D: string;
  _RateDCPiece2D: string;
  _FromDCKG2D: string;
  _ToDCKG2D: string;
  _RateDCKG2D: string;
  _FromDDPiece2D: string;
  _ToDDPiece2D: string;
  _RateDDPiece2D: string;
  _FromDDKG2D: string;
  _ToDDKG2D: string;
  _RateDDKG2D: string;
  _FromACPiece2D: string;
  _ToACPiece2D: string;
  _RateACPiece2D: string;
  _FromACKG2D: string;
  _ToACKG2D: string;
  _RateACKG2D: string;
  _Piece2D: any[] = [];
  _KG2D: any[] = [];
  _DCPiece2D: any[] = [];
  _DCKG2D: any[] = [];
  _DDPiece2D: any[] = [];
  _DDKG2D: any[] = [];
  _ACPiece2D: any[] = [];
  _ACKG2D: any[] = [];
  _2DList: any[] = [];
  _updateRow2D: boolean = true;
  _addRow2D: boolean = false;
  _2DIndex: any = null;
  _2DFormsubmitted: boolean = false

  ///////--------------Way Bill-------------//////////////

  displayRateTypeWayBill: boolean;
  displayPieceWayBill: boolean;
  displayKGWayBill: boolean;
  displayPieceKGWayBill: boolean;
  _WaybillForm: FormGroup
  _FromPieceWayBill: string;
  _ToPieceWayBill: string;
  _RatePieceWayBill: string;
  _FromKGWayBill: string;
  _ToKGWayBill: string;
  _RateKGWayBill: string;
  _FromPieceKGWayBill: string;
  _ToPieceKGWayBill: string;
  _RatePieceKGWayBill: string;
  WayBillList: CustomerSiteContractAddOnCharge[] = [];
  _WayBillListGrid: CustomerSiteContractAddOnCharge[] = [];
  _PieceWayBill: any[] = [];
  _KGWayBill: any[] = [];
  _PieceKGWayBill: any[] = [];
  _AddOnChargeType: any[];
  _ApprovalComment: any[];
  _updateRowWayBill: boolean = true;
  _addRowWayBill: boolean = false;
  _WayBillIndex: any = null;
  _WaybillFormsubmitted: boolean = false


  
  _TempPieceKG: string;	

  HideDCPieceAdditionalRate: boolean = true	
  HideDCPieceAdditionalRateMsg: boolean = true			
  _DCPieceAdditionalRate: string;
  HideDCKGAdditionalRate: boolean = true			
  _DCKGAdditionalRate: string;
  HideDCKGAdditionalRateMsg: boolean = true	

  HideDDPieceAdditionalRate: boolean = true	
  HideDDPieceAdditionalRateMsg: boolean = true			
  _DDPieceAdditionalRate: string;
  HideDDKGAdditionalRate: boolean = true			
  _DDKGAdditionalRate: string;
  HideDDKGAdditionalRateMsg: boolean = true	

  HideACPieceAdditionalRate: boolean = true	
  HideACPieceAdditionalRateMsg: boolean = true			
  _ACPieceAdditionalRate: string;
  HideACKGAdditionalRate: boolean = true			
  _ACKGAdditionalRate: string;
  HideACKGAdditionalRateMsg: boolean = true	

  HideDCPieceAdditionalRateAB: boolean = true	
  HideDCPieceAdditionalRateMsgAB: boolean = true			
  _DCPieceAdditionalRateAB: string;
  HideDCKGAdditionalRateAB: boolean = true			
  _DCKGAdditionalRateAB: string;
  HideDCKGAdditionalRateMsgAB: boolean = true	

  HideDDPieceAdditionalRateAB: boolean = true	
  HideDDPieceAdditionalRateMsgAB: boolean = true			
  _DDPieceAdditionalRateAB: string;
  HideDDKGAdditionalRateAB: boolean = true			
  _DDKGAdditionalRateAB: string;
  HideDDKGAdditionalRateMsgAB: boolean = true	

  HideACPieceAdditionalRateAB: boolean = true	
  HideACPieceAdditionalRateMsgAB: boolean = true			
  _ACPieceAdditionalRateAB: string;
  HideACKGAdditionalRateAB: boolean = true			
  _ACKGAdditionalRateAB: string;
  HideACKGAdditionalRateMsgAB: boolean = true	

  HideDCPieceAdditionalRateSP: boolean = true	
  HideDCPieceAdditionalRateMsgSP: boolean = true			
  _DCPieceAdditionalRateSP: string;
  HideDCKGAdditionalRateSP: boolean = true			
  _DCKGAdditionalRateSP: string;
  HideDCKGAdditionalRateMsgSP: boolean = true	

  HideDDPieceAdditionalRateSP: boolean = true	
  HideDDPieceAdditionalRateMsgSP: boolean = true			
  _DDPieceAdditionalRateSP: string;
  HideDDKGAdditionalRateSP: boolean = true			
  _DDKGAdditionalRateSP: string;
  HideDDKGAdditionalRateMsgSP: boolean = true	

  HideACPieceAdditionalRateSP: boolean = true	
  HideACPieceAdditionalRateMsgSP: boolean = true			
  _ACPieceAdditionalRateSP: string;
  HideACKGAdditionalRateSP: boolean = true			
  _ACKGAdditionalRateSP: string;
  HideACKGAdditionalRateMsgSP: boolean = true	


  HideDCPieceAdditionalRate2D: boolean = true	
  HideDCPieceAdditionalRateMsg2D: boolean = true			
  _DCPieceAdditionalRate2D: string;
  HideDCKGAdditionalRate2D: boolean = true			
  _DCKGAdditionalRate2D: string;
  HideDCKGAdditionalRateMsg2D: boolean = true	

  HideDDPieceAdditionalRate2D: boolean = true	
  HideDDPieceAdditionalRateMsg2D: boolean = true			
  _DDPieceAdditionalRate2D: string;
  HideDDKGAdditionalRate2D: boolean = true			
  _DDKGAdditionalRate2D: string;
  HideDDKGAdditionalRateMsg2D: boolean = true	

  HideACPieceAdditionalRate2D: boolean = true	
  HideACPieceAdditionalRateMsg2D: boolean = true			
  _ACPieceAdditionalRate2D: string;
  HideACKGAdditionalRate2D: boolean = true			
  _ACKGAdditionalRate2D: string;
  HideACKGAdditionalRateMsg2D: boolean = true	

  HideACPieceAdditionalRateWH: boolean = true	
  HideACPieceAdditionalRateMsgWH: boolean = true			
  _ACPieceAdditionalRateWH: string;
  HideACKGAdditionalRateWH: boolean = true			
  _ACKGAdditionalRateWH: string;
  HideACKGAdditionalRateMsgWH: boolean = true	



  _StateMinimumODACharges: string;
  _FlatMinimumODACharges: string;
  _ArticleFrom: string;
  _ArticleTo: string;
  _ArticleCharges: string;
  _KGFrom: string;
  _KGTo: string;
  _KGCharges: string;
  _KGList: any[] = [];
  _ArticleList: any[] = [];
  _selectedDocumentsContract: File[] = [];
  currentFileContract: File;



  CustomerSiteContractList: CustomerSiteContract;
  _CustomerSiteContractGeneralForm: FormGroup;
  _contracttypescode: string;
  _contracttypes_: string;
  _ServiceableMinimumODACharges: string;
  _TranscationODACharges: string;
  _TranscationMinimumODACharges: string;
  _StateCode: string;
  ExistCustomerContract: any[];
  _ContractTypes: string[] = [];
  _StateNG: string[] = [];
  _TempWaybillList: any[];
  _CostingContractsubmitted: boolean = false
  _CustomerSiteContractGeneralFormsubmitted: boolean = false
  _ODAChargesAgree: any[]
  _ODACalculationMode: any[]
  selectedtabContract: number = 5;

  HideGeneralRate: boolean = false
  HideArticleBased: boolean = false
  HideRegionLevel: boolean = false
  HideSlab: boolean = false
  Hide2DRate: boolean = false
  _approvalid: string;
  _workflowid: string;
  _Comments: string;
  _approval: Approval;
  _buttonHide: boolean = false;
  _Approvalcode: string = 'MSC00148';
  _ReferBackcode: string = 'MSC00486';
  _Rejectcode: string = 'MSC00149';
  _SuccessMSG: string;

  _ApprovalHide: boolean = false;
  _ReferBackHide: boolean = false;
  _RejectHide: boolean = false;

  _approvalform: FormGroup
  TempExistCustomerContract: any
  CommunicationMail: any

  hideAgent: boolean = true


  ////////////////--------------------DCDDAC--------------------//////////////

  _DCDDACForm: FormGroup;

  displayBulckDC: boolean
  displayKGBulckDC: boolean
  _FromPieceBulckDC: string
  _ToPieceBulckDC: string
  _RatePieceBulckDC: string
  _FromKGBulckDC: string
  _ToKGBulckDC: string
  _RateKGBulckDC: string
  _PieceBulckDC: any[] = []
  _KGBulckDC: any[] = []

  displayBulckDD: boolean
  displayKGBulckDD: boolean
  _FromPieceBulckDD: string
  _ToPieceBulckDD: string
  _RatePieceBulckDD: string
  _FromKGBulckDD: string
  _ToKGBulckDD: string
  _RateKGBulckDD: string
  _PieceBulckDD: any[] = []
  _KGBulckDD: any[] = []

  displayBulckAC: boolean
  displayKGBulckAC: boolean
  _FromPieceBulckAC: string
  _ToPieceBulckAC: string
  _RatePieceBulckAC: string
  _FromKGBulckAC: string
  _ToKGBulckAC: string
  _RateKGBulckAC: string
  _PieceBulckAC: any[] = []
  _KGBulckAC: any[] = []

  TempWaybillList_: any[]
  TempRegionlevelList_: any[]
  TempArticlelList_: any[]
  TempSlabList_: any[]
  TempDDList_: any[]


  WaybillselectedFiles: FileList;
  RegionLevelselectedFiles: FileList;
  ArticleselectedFiles: FileList
  SlabselectedFiles: FileList
  DDselectedFiles: FileList

  ValidateRegion: boolean = true
  ValidateArticle: boolean = true
  ValidateSlab: boolean = true
  ValidateDD: boolean = true

  ValidateSpecial: boolean = true
  ValidateTAT: boolean = true

  _VerificationMask: string;

  _SkuLength: boolean = true
  _SkuBreadth: boolean = true
  _SkuHeight: boolean = true
  _CftBasedOn: boolean = true
  _CftWeight: boolean = false


  _Designation: any
  _listDistance: any[] = []
  _VolBasedOn: any = [
    { volumetricid: '1', volumetricname: 'CFT' },
    { volumetricid: '2', volumetricname: 'Actual Weight' }
  ]
  _SkuTypeList: any[]
  _Quote: any;
  DisableMail: boolean = false
  @ViewChild("search")
  public searchElementRef: ElementRef
  @ViewChild("editor", { static: true }) private editor: ElementRef<HTMLElement>;

  @ViewChild('takeInput', { static: false })
  InputVar: ElementRef;
  @ViewChild('takeInputTAT', { static: false })
  InputVarTAT: ElementRef;
  @ViewChild('takeRegionLevelInput', { static: false })
  InputVarRegion: ElementRef;
  @ViewChild('takeArticleBasedInput', { static: false })
  InputVarArticle: ElementRef;
  @ViewChild('takeSlabInput', { static: false })
  InputVarSlab: ElementRef;
  @ViewChild('take2drateInput', { static: false })
  InputVarDDRate: ElementRef;
  takeRegionLevelInput: ElementRef
  constructor(
    public sanitizer: DomSanitizer,
    private fb: FormBuilder, private router: Router,
    private _ServiceLocationAndOperationService: ServiceLocationAndOperationService,
    public exportUtility: ExportUtility,
    private utility: CommonUtilities,
    private _CustomerInformationService: CustomerinformationService,
    private _CustomExceptionService: CustomExceptionService,
    private _ExistingvendorService: ExistingvendorService,
    private _TradereferenceService: TradereferenceService,
    public keypress: KeyPress,
    private _CustomerSUKService: CustomerSUKService,
    private _APIdService: APIService,
    private _DomSanitizationService: DomSanitizer,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _CustomerSiteCostAndContractService: CustomerSiteCostAndContractService,
    private route: ActivatedRoute,
    private _ApprovalService: ApprovalService,
    private _PrequoteApprovalService: PrequoteApprovalService
  ) {
    this.CustomersiteCode = history.state?.sitecode;
   }

  ngOnInit(): void {
    // alert(this.CustomersiteCode);
    this.searchControl = new FormControl();
    this.zoom = 12;
    this.latitude = 13.0364756;
    this.longitude = 80.1892982;
    //set current position
    this.setCurrentPosition();


    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //types: ["address"]
        //types: ['(cities)']
      });
      autocomplete.addListener("place_changed", () => {  //place_changed ///place_changed
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this._CustomerSiteform.controls['latitude'].setValue(this.latitude);
          this._CustomerSiteform.controls['longitude'].setValue(this.longitude);
          this._CustomerSiteform.controls['googlelocation'].setValue(place.formatted_address);
          // alert(this._CustomerSiteform.get("googlelocation").value)
        });
      });
    }); this._BasedonSKU = [
      { id: '6', name: '6' },
      { id: '8', name: '8' },
      { id: '10', name: '10' }

    ]
    //////////////////---------CUSTOMER FORMS--------------/////////////////////
    this._CustomerSiteform = this.fb.group({
      customercode: [],
      customersitecode: [],
      customersitename: ['', vCustomersite],
      credittypecode: ['', vCustomersite],
      credittypes: [],
      acquiredbycode: ['', vCustomersite],
      acquiredby: [],
      agentname: [],
      billingtocode: ['', vCustomersite],
      billingto: [],
      productname: ['', vCustomersite],
      producttypecode: ['', vCustomersite],
      producttype: [],
      gstin: ['', vCustomersite],
      gstStatuscode: ['', vCustomersite],
      gstStatus: [],
      validationbasedoncode: ['', vCustomersite],
      validationbasedon: [],
      idNumber: ['', vCustomersite],
      //client_id:[],
      // AadharOTPVerification:[],
      onBehalfOf: [],
      gstValidationstatuscode: [],
      gstValidationstatus: [],
      googlelocation: [],
      latitude: [],
      longitude: [],
      pickuplocationphotoURL: [],
      // pickuplocationphotoFORMFILE: [],
      pickuplocationintime: ['', vCustomersite],
      pickuplocationouttime: ['', vCustomersite],
      pickuplocationobservations: ['', vCustomersite],
      recordstatus: [],
      createdby: [],
      modifiedby: [],
      createdon: [],
      modifiedon: [],
      accountingyear: [],
      lstCustomerSiteAddress: [],
      lstCustomerSiteContact: [],
      customername: [],
      companytypecode: [],
      companytype: [],
      tallyid: [],
      pan: [],
      billingcyclecode: [],
      billingcycle: [],
      istransportercode: [],
      istransporter: [],
      prequotestatuscode: [],
      prequotestatus: [],
      recordstatuscode: [],
      comments: [],
      signedcontractdocumentURL: [],
      cutoffdateforsignedcontract: [],
      prequotesignoffcomments: [],
      prequotesignedoffby: [],
      prequotesignedon: [],
      isspecialdelivery: [],
      lrcopyrequired: [],
      invoiceconfiguration: [],
      gstapplicable: [false],
      joborderdate: [false],
      isewaybillmandatory: [false],
      waybilltotalamount: [false],
      waybillsplitupamount: [false],
      gstFile: []
      // isTemp: [],
      // customersitename:[]
      // totalspendtime: []
    });
    this._CustomerAddressPickupform = this.fb.group({
      addressid: [],
      customersitecode: [],
      addresstype: [],
      address: ['', vCustomersite],
      taluk: [],
      pincode: ['', vCustomersite],
      pincodelocation: ['', vCustomersite],
      floortype: ['', vCustomersite],
      addresstypecode: [],
      recordstatuscode: [],
      floortypecode: [],
      recordstatus: []
    });
    this._CustomerAddressBillingform = this.fb.group({
      addressid: [],
      customersitecode: [],
      addresstype: [],
      address: ['', vCustomersite],
      taluk: [],
      pincode: ['', vCustomersite],
      pincodelocation: ['', vCustomersite],
      floortype: ['', vCustomersite],
      addresstypecode: [],
      recordstatuscode: [],
      floortypecode: [],
      recordstatus: []
    });
    this._CustomerContactPickform = this.fb.group({
      contactid: [],
      customersitecode: [],
      contacttype: [],
      contactperson: ['', vCustomersite],
      designation: ['', vCustomersite],
      department: ['', vCustomersite],
      phoneno: [],
      mobileno: ['', vCustomersite],
      emailid: ['', vcusEmailID],
      faxno: [],
      contacttypecode: [],
      recordstatuscode: [],
      recordstatus: []
    });
    // this._CustomerContactInvoiceform = this.fb.group({
    //   contactid: [],
    //   customersitecode: [],
    //   contacttype: [],
    //   contactperson: ['', vCustomersite],
    //   designation: ['', vCustomersite],
    //   department: ['', vCustomersite],
    //   phoneno: [],
    //   mobileno: ['', vCustomersite],
    //   emailid: ['', vcusEmailID],
    //   faxno: [],
    //   contacttypecode: [],
    //   recordstatuscode: [],
    //   recordstatus: []
    // });
    // this._CustomerContactOutgoingform = this.fb.group({
    //   contactid: [],
    //   customersitecode: [],
    //   contacttype: [],
    //   contactperson: ['', vCustomersite],
    //   designation: ['', vCustomersite],
    //   department: ['', vCustomersite],
    //   phoneno: [],
    //   mobileno: ['', vCustomersite],
    //   emailid: ['', vcusEmailID],
    //   faxno: [],
    //   contacttypecode: [],
    //   recordstatuscode: [],
    //   recordstatus: []
    // });
    this._Tempform = this.fb.group({

      companytype: [],
      billingcycle: [],
      customername: [],
      sameaddress: [],
      totalspendtime: []
    })
    this._TempformforTab = this.fb.group({
      TabName: [],
    })
    this._TempformAD = this.fb.group({
      client_id: [],
      AadharOTPVerification: []
    })

    /////////////////costing & contract/////////////////////////////

    this._CostingContract = this.fb.group({
      billingbranchcode: ['', vContract],
      billingbranch: ['', vContract],
      communicationmaildocumentURL: [],
      communicationmaildocumentDOC: [],
      odachargetype: [],
      odachargetypecode: ['', vContract],
      pertransactionfixedodacharges: [],
      opentypeodastates: [],
      flatodabasedon: [],
      fuelpriceperltr: ['', vContract],
      quotedrateperqtlperkm: ['', vContract],
      minimumfreight: [0, vContract],
      minimumchargeableweight: [0, vContract],
      minimumvsc: ['', vContract],
      quotestatus: ['', vContract],
      expectedsales: ['', vContract],
      creditlimit: ['', vContract],
      invoicecreditdays: ['', vContract],
      minimumdc: ['', vContract],
      costtocompanydc: ['', vContract],
      costtoagentdc: ['', vContract],
      minimumdd: ['', vContract],
      minarticledd: ['', vContract],
      costtocompanydd: ['', vContract],
      costtoagentdd: ['', vContract],
      minimumac: ['', vContract],
      costtocompanyac: ['', vContract],
      costtoagentac: ['', vContract],
      contracttypescode: [],
      odainclusiveorexclusivecode: [],
      opentypeodastatescode: [],
      flatodabasedoncode: [],
      odachargesagreed: [],
      odachargesagreedcode: [],
      costtocompanyoda: [],
      costtoagentoda: [],
      odainclusiveorexclusive: [],
      minimumoda: [],
      contracttypes: ['', vContract],
      loadingchargesbyagent:[],
      loadingchargesbycustomer:[],
      //lstFlatODACharges:[],
      //lstGeneralContract:[],
      //lstRegionContract:[],
      //lstArticleContract:[],
      //lstSlabContract:[],
      //lstTwoDContract:[],
      //lstAddOnCharge:[],
      //lstAddOnSlabs:[],
      //lstDCDDACSlabs:[],
      //lstAddOnSlabs:[],
      //lstAddOnCharge:[],
      //lstAddOnCharge:[],
    })


    this._DCDDACForm = this.fb.group({
      dccharges: [],
      ddcharges: [],
      accharges: [],
      dcchargestypecode: [],
      ddchargestypecode: [],
      acchargestypecode: [],
    })

    this._CostingContract.controls['costtoagentdc'].setValue(100);
    this._CostingContract.controls['costtoagentdd'].setValue(100);
    this._CostingContract.controls['costtoagentac'].setValue(100);
    this._CostingContract.controls['costtoagentoda'].setValue(100);


    this._CustomerSiteContractGeneralForm = this.fb.group({
      rateperqtlperkm: ['0', vContract],
      odacalculationmodecode: ['', vContract],
    })

    this._RegionLevelForm = this.fb.group({
      frombranchcode: ['', vContract],
      toregioncode: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],

      acratetype: [],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
    })

    this._ArticleBasedForm = this.fb.group({
      frombranchcode: ['', vContract],
      tobranchcode: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      kg: [],
      rateperkm: [1.44, vContract],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
      acratetype: [],
    })

    this._SlabForm = this.fb.group({
      frombranchcode: ['', vContract],
      tobranchcode: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acratetype: [],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
    })

    this._2DForm = this.fb.group({
      frombranchcode: ['', vContract],
      toKM: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acratetype: [],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
    })

    this._WaybillForm = this.fb.group({
      chargecodeid: [],
      chargetypecode: ['', vContract],
      chargeratetypecode: ['', vContract],
      rate: [],
      inclusiveorexclusivecode: ['', vContract],
      printinothercharge: [],
    })



    // lstCustomer



    /*this._Tempform = this.fb.group({
      TabName: [],
    })*/
    ////////////////////-------------SERVICE LOCATIONS FORM-----------------/////////////////////
    this._TempformforTab.get("TabName").setValue(0);
    this._ServiceLocationAndOperation_Form = this.fb.group({
      servicelocationscode: ['', vServiceLocations],
      tiercode: ['', vServiceLocations],
      podrequirementcode: ['', vServiceLocations],
      bookingcutofftime: ['', vServiceLocations],
      vehicledeparturecutofftime: ['', vServiceLocations],
      pickupcutofftime: ['', vServiceLocations],
      odalocation: ['', vServiceLocations],
      customerlrcopy: ['', vServiceLocations],
      invoiceacknowledgement: ['', vServiceLocations],
      returnbooking: ['', vServiceLocations],
      specialDelivery: ['', vServiceLocations],
      tatDetails: ['', vServiceLocations],
      taTbasedInternalRemarks: [],
    })
    this._ServiceLocationAndOperation_SpecialDelivery_Form = this.fb.group({
      operationSpecialDeliverytypecode: ['', vServiceLocations],
      rateType: ['', vServiceLocations],
      deliveryCharges: ['', vServiceLocations],
    })
    this._ServiceLocationAndOperation_TATDetails_Form = this.fb.group({
      //Basedoncode: ['', vServiceLocations],
      Fromlocationcode: ['', vServiceLocations],
      Tolocationcode: ['', vServiceLocations],
      Tatindays: ['', vServiceLocations],
      //TabName3:[],
    })
    ////////////////------------------SKU FORMS ---------------////////////////////
    this._SUK_Form = this.fb.group({
      SkuType: ['', vSUK],
      SkuUom: [],
      SkuLength: [],
      SkuBreadth: [],
      SkuHeight: [],
      CftBasedOn: [],
      CftWeight: ['', vSUK],
      ContributionPercentage: ['', vSUK],
      SkuPhotoURL: [],
      //SkuPhotoFORMFILE:[],  
    })
    this._SUK_Form.controls['SkuLength'].disable();
    this._SUK_Form.controls['SkuBreadth'].disable();
    this._SUK_Form.controls['SkuHeight'].disable();
    this._SUK_Form.controls['CftBasedOn'].disable();
    this._SUK_VolumeDistrubution_Form = this.fb.group({
      Hub: ['', vSUK],
      VolumeDistributionPercentage: ['', vSUK],
    })

    this._approvalform = this.fb.group({
      APPROVALID: [],
      WORKFLOWID: [],
      LEVELAPPROVALSTATE: [],
      Remarks: [],
      lstCustomerSiteTradeReference: []
    });

    this.PageLoad();
    
  }
  setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = parseFloat(this._CustomerSiteform.get("latitude").value);
        this.longitude = parseFloat(this._CustomerSiteform.get("longitude").value);
        // this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  PageLoad() {
    this._PrequoteApprovalService.GetPageInitializeDetails().subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log("rest", resultJSON);
      ////////---Customer---/////////
      this._CreditType = resultJSON.lstCreditType
      this._FloorType = resultJSON.lstFloorType
      this._AccquiredAgent = resultJSON.lstAcquiredBy
      this._Agent = resultJSON.lstAgent
      this._ProductType = resultJSON.lstProductType
      this._GSTStatus = resultJSON.lstGSTstatus
      this._Basedon = resultJSON.lstValidationBasedOn
      this.Temp_Basedon = resultJSON.lstValidationBasedOn
      this._BillingTo = resultJSON.lstBillingTo
      this._CustomerList = resultJSON.lstCustomer
      this._PincodeLocation = resultJSON.lstPincodeLocation
      this._PincodeLocation1 = resultJSON.lstPincodeLocation
      ////////---Service Location and operation---/////////
      this._ServiceLocation = resultJSON.lstServiceLocation;
      this._Tier = resultJSON.lstTier;
      this._Requirments = resultJSON.lstPODRequirement;
      this._SpecialDelivery = resultJSON.lstSpecialDeliveryType;
      this._SLFloorType = resultJSON.lstFloorType;
      this._TempSLPincodeLocation = resultJSON.lstPincodeLocation;
      this._TatBased = resultJSON.lstTATBasedOn;
      this._Location = resultJSON.lstTATLocation;
      this._ODALocations = resultJSON.lstYesNo;
      this._RateType_ = resultJSON.lstRateType;
      ////////---SKU---/////////
      this._Uom = resultJSON.lstSKUUom;
      this._Hub = resultJSON.lstHub;
      ////////---Contract---/////////
      this._BillingBranch = resultJSON.lstBranch;
      this._FlatOdaList = resultJSON.lstFlatODABasedOn;
      this._ContractType = resultJSON.lstContractType;
      this._InclusiveExclusive = resultJSON.lstODAInclusiveOrExclusive;
      this._State = resultJSON.lstState;
      this._Region = resultJSON.lstRegion;
      this._ODAChargesAgree = resultJSON.lstYesNo;
      this._ODACalculationMode = resultJSON.lstODACalculationMode;
      this._ToBranch = resultJSON.lstBranch;
      this._ArticleName = resultJSON.lstArticle;
      this._RateType = resultJSON.lstRateType;
      this._DCRateType = resultJSON.lstDCRateType;
      this._DDRateType = resultJSON.lstDDRateType;
      this._ArticleChargeCode = resultJSON.lstACRateType;
      this._AddonCharges = resultJSON.lstChargeType;
      this._AddOnChargeType = resultJSON.lstAddOnChargeType;
      this._OdaList = resultJSON.lstODAChargeType
      this._SlabType = resultJSON.lstSlabType;
      this._Designation = resultJSON.lstDesignation
      this._Quote = resultJSON.lstQuoteStatus

      ////////---Existing Vendor---/////////
      ////////---Trade Reference---/////////

      this.PageGetbyId();
      // this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").setValue("PQT00048");
      // lstCustomer
    }, error => { this._CustomExceptionService.handleError(error); }
    );
  }
  PageGetbyId() {
    if (this.CustomersiteCode != null || this.CustomersiteCode != undefined || this.CustomersiteCode != "") {
      this._PrequoteApprovalService.GetById(this.CustomersiteCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log("dd values", resultJSON);
        if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
          this._CustomerDetail = resultJSON.customerSiteDetail
          this._CustomerDetailTemp = resultJSON.customerSiteDetail
          this.CustomerCode = resultJSON.customercode


          ///////----------- customersitecode---------------//////////////////
          if (resultJSON.customerSiteDetail != null) {
            this._Tempform.controls['companytype'].setValue(resultJSON.customerSiteDetail.companytype);
            this._Tempform.controls['billingcycle'].setValue(resultJSON.customerSiteDetail.billingcycle);
            resultJSON.customerSiteDetail.pickuplocationintime = new Date(resultJSON.customerSiteDetail.pickuplocationintime);
            resultJSON.customerSiteDetail.pickuplocationouttime = new Date(resultJSON.customerSiteDetail.pickuplocationouttime);
            // this._CustomerSiteform.get("pickuplocationintime").setValue(resultJSON.customerSiteDetail.pickuplocationintime)
            // this._CustomerSiteform.get("pickuplocationouttime").setValue(resultJSON.customerSiteDetail.pickuplocationouttime)
            // var spendtime = resultJSON.customerSiteDetail.pickuplocationouttime.getHours() - resultJSON.customerSiteDetail.pickuplocationintime.getHours()
            // this._Tempform.get("totalspendtime").setValue(spendtime)
            // this.imageselect = resultJSON.customerSiteDetail.pickuplocationphotoURL

            var date1 = resultJSON.customerSiteDetail.pickuplocationouttime
            var date2 = resultJSON.customerSiteDetail.pickuplocationintime
            var Time = date1.getTime() - date2.getTime();
            var hours = parseInt(Time / (1000 * 3600) + ''); //Diference in Days.
            this._Tempform.get("totalspendtime").setValue(hours)

            this.imageselect = resultJSON.customerSiteDetail.pickuplocationphotoURL
            this.GSTimageselect = resultJSON.customerSiteDetail.gstFile
            // alert(this.imageselect)
            this.CustomersiteCode = resultJSON.customerSiteDetail.customersitecode
            this._CustomerAddressPickupform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0])
            this._CustomerAddressBillingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1])
            this._CustomerContactPickform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[0])
            // this._CustomerContactInvoiceform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[1])
            // this._CustomerContactOutgoingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[2])
            this.addressid = this._CustomerDetail.lstCustomerSiteAddress[0].addressid
            this.addressid1 = this._CustomerDetail.lstCustomerSiteAddress[1].addressid
            this.contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid
            // this.contactid1 = this._CustomerDetail.lstCustomerSiteContact[1].contactid
            // this.contactid2 = this._CustomerDetail.lstCustomerSiteContact[2].contactid
            this._CustomerAddressPickupform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].floortypecode);
            this._CustomerAddressBillingform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].floortypecode);
            var PinCode = this._CustomerAddressPickupform.get("pincode").value;
            // console.log("PINCODE",this._PincodeLocation)
            this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);

            this._CustomerAddressPickupform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation);
            var PinCode1 = this._CustomerAddressBillingform.get("pincode").value;
            this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
            this._CustomerAddressBillingform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].pincodelocation);

            if (resultJSON.customerSiteDetail.acquiredbycode == "MSC00039") {
              this.hideAgent = false
            } else {
              this.hideAgent = true
            }

            // console.log("loc", resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation)
            this.creditCode = resultJSON.customerSiteDetail.credittypecode
            this._CustomerSiteform.setValue(resultJSON.customerSiteDetail);
            if (resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].address == resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].address) {
              this._Tempform.controls["sameaddress"].setValue(true)
            }
            if (resultJSON.customerSiteDetail.credittypecode != null) {
              var _CrediTypeCode = resultJSON.customerSiteDetail.credittypecode.split(',');
              var CreditTypeCode: string[] = [];
              Object.keys(_CrediTypeCode).map((Index) => {
                CreditTypeCode.push(_CrediTypeCode[Index]);
              });
              this._CreditTypeCode_ = CreditTypeCode;
            }
            this.validationStatusCode = resultJSON.customerSiteDetail.gstValidationstatuscode
            
          }
          ////////////////////////////////////-------------Service Location and operation-------------------------/////////
          if (resultJSON.customerSiteOperationDetail != null) {
            var splitServiceLocation = resultJSON.customerSiteOperationDetail.servicelocations.split(',');
            const servicelocations = [];
            for (i = 0; i < splitServiceLocation.length; i++) {
              servicelocations.push(splitServiceLocation[i]);
            }
            var servicelocationsCode: string[] = [];
            Object.keys(servicelocations).map((Index) => {
              servicelocationsCode.push(servicelocations[Index]);
              //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
            });
            this._selectedServiceLocation = servicelocationsCode;
            var splittier = resultJSON.customerSiteOperationDetail.tiercode.split(',');
            const tier = [];
            for (i = 0; i < splittier.length; i++) {
              tier.push(splittier[i]);
            }
            var tierCode: string[] = [];
            Object.keys(tier).map((Index) => {
              tierCode.push(tier[Index]);
              //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
            });
            this._selectedtier = tierCode;
            this._TempServiceLocationsCode = resultJSON.customerSiteOperationDetail.servicelocations;
            this._TempTierCode = resultJSON.customerSiteOperationDetail.tiercode;
            this._TempPODCode = resultJSON.customerSiteOperationDetail.podrequirementcode;

            ////////////////////POD////////////////
            var splitPOD = resultJSON.customerSiteOperationDetail.podrequirementcode.split(',');
            const POD = [];
            for (i = 0; i < splitPOD.length; i++) {
              POD.push(splitPOD[i]);
            }
            var PODRequirementCode: string[] = [];
            Object.keys(POD).map((Index) => {
              PODRequirementCode.push(POD[Index]);
            });
            this._selectedPODReq = PODRequirementCode;

            //this._ServiceLocationAndOperation_Form.get("tiercode").setValue(this._Tier.find(f => f.metasubcode === resultJSON.customerSiteOperationDetail.tiercode));
            //this._ServiceLocationAndOperation_Form.get("podrequirementcode").setValue(resultJSON.customerSiteOperationDetail.podrequirementcode);
            this._ServiceLocationAndOperation_Form.controls['bookingcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.bookingcutofftime));
            this._ServiceLocationAndOperation_Form.controls['vehicledeparturecutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.vehicledeparturecutofftime));
            this._ServiceLocationAndOperation_Form.controls['pickupcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.pickupcutofftime));
            this._ServiceLocationAndOperation_Form.controls['odalocation'].setValue(resultJSON.customerSiteOperationDetail.odalocationcode);
            this._ServiceLocationAndOperation_Form.controls['customerlrcopy'].setValue(resultJSON.customerSiteOperationDetail.customerlrcopycode);
            this._ServiceLocationAndOperation_Form.controls['invoiceacknowledgement'].setValue(resultJSON.customerSiteOperationDetail.invoiceacknowledgementcode);
            this._ServiceLocationAndOperation_Form.controls['returnbooking'].setValue(resultJSON.customerSiteOperationDetail.returnbookingcode);
            this._ServiceLocationAndOperation_Form.controls['specialDelivery'].setValue(resultJSON.customerSiteOperationDetail.specialDelivery);
            this._ServiceLocationAndOperation_Form.controls['tatDetails'].setValue(resultJSON.customerSiteOperationDetail.tatDetails);
            this._ServiceLocationAndOperation_Form.controls['taTbasedInternalRemarks'].setValue(resultJSON.customerSiteOperationDetail.taTbasedInternalRemarks);
            if(resultJSON.customerSiteOperationDetail.specialDelivery != null && resultJSON.customerSiteOperationDetail.specialDelivery != undefined && resultJSON.customerSiteOperationDetail.specialDelivery != '')
            {
              if (resultJSON.customerSiteOperationDetail.specialDelivery == 'MSC00012') {
                this.SpecialDeliveryList = [];
                this.hidd_SpecialDelivery = true;
              }
              else {
                this.hidd_SpecialDelivery = false;
              }
            }
            if(resultJSON.customerSiteOperationDetail.tatDetails != null && resultJSON.customerSiteOperationDetail.tatDetails != undefined && resultJSON.customerSiteOperationDetail.tatDetails != '')
            {
              if (resultJSON.customerSiteOperationDetail.tatDetails != 'PQT00048') {
                this.TATDetails = [];
                this.hidd_TATDetails = true;
                this.hidd_TATInternalDetails = false;
              }
              else {
                this.hidd_TATDetails = false;
                this.hidd_TATInternalDetails = true;
              }
            }
            this.SpecialDeliveryList = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery;
            for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery.length; i++) {
              this.SpecialDeliveryList[i].SpecialDeliverytypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].specialDeliverytypecode
              this.SpecialDeliveryList[i].SpecialDeliverytype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].specialDeliverytype
              this.SpecialDeliveryList[i].contactPerson = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].contactPerson
              this.SpecialDeliveryList[i].MobileNo = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].mobileNo
              this.SpecialDeliveryList[i].EmailID = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].emailID
              this.SpecialDeliveryList[i].Address = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].address
              this.SpecialDeliveryList[i].pincode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].pincode
              this.SpecialDeliveryList[i].PincodeLocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].pincodeLocation
              this.SpecialDeliveryList[i].Floortypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].floortypecode
              this.SpecialDeliveryList[i].Floortype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].floortype
              this.SpecialDeliveryList[i].InclusiveorexclusiveName = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].inclusiveorexclusiveName;
            }
            this.TATDetails = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT;
            for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT.length; i++) {
              this.TATDetails[i].Basedoncode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedoncode
              this.TATDetails[i].Basedon = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedon
              this.TATDetails[i].Fromlocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocationcode
              this.TATDetails[i].Fromlocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocation
              this.TATDetails[i].Tolocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocationcode
              this.TATDetails[i].Tolocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocation
              //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
              this.TATDetails[i].Tatindays = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tatindays
            }
            
          }
          ////////////////////////////////////-------------------SKU-------------------------/////////
          if (resultJSON.lstCustomerSiteSKU != null) {
            this.QuantityPer = 0
            this.volumeQuantity = 0
            this.SUKList = resultJSON.lstCustomerSiteSKU;
            for (var i = 0; i < resultJSON.lstCustomerSiteSKU.length; i++) {
              this.SUKList[i].SkuType = resultJSON.lstCustomerSiteSKU[i].skuType
              this.SUKList[i].SkuUom = resultJSON.lstCustomerSiteSKU[i].skuUom
              this.SUKList[i].SkuUomCode = resultJSON.lstCustomerSiteSKU[i].skuUomCode
              this.SUKList[i].SkuLength = resultJSON.lstCustomerSiteSKU[i].skuLength
              this.SUKList[i].SkuBreadth = resultJSON.lstCustomerSiteSKU[i].skuBreadth
              this.SUKList[i].SkuHeight = resultJSON.lstCustomerSiteSKU[i].skuHeight
              this.SUKList[i].CftBasedOn = resultJSON.lstCustomerSiteSKU[i].cftBasedOn
              this.SUKList[i].CftWeight = resultJSON.lstCustomerSiteSKU[i].cftWeight
              this.SUKList[i].ContributionPercentage = resultJSON.lstCustomerSiteSKU[i].contributionPercentage
              this.SUKList[i].SkuPhotoURL_ = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL
              var filename = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.substring(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.lastIndexOf('/') + 1);
              this.SUKList[i].SkuPhotoURLName = filename;
              this.SUKList[i].SkuPhotoFORMFILE = null
              this.SUKList[i].Customersitecode = resultJSON.lstCustomerSiteSKU[i].customersitecode;
              var Quantity = parseFloat(this.QuantityPer) + parseFloat(resultJSON.lstCustomerSiteSKU[i].contributionPercentage);
              this.QuantityPer = Quantity;
            }
          }
          if (resultJSON.lstCustomerSiteSKUVolumeDistribution != null) {
            this.SUKVolumeDistrubutionList = resultJSON.lstCustomerSiteSKUVolumeDistribution;
            for (var i = 0; i < resultJSON.lstCustomerSiteSKUVolumeDistribution.length; i++) {
              this.SUKVolumeDistrubutionList[i].Hub = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hub;
              this.SUKVolumeDistrubutionList[i].HubCode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hubCode;
              this.SUKVolumeDistrubutionList[i].VolumeDistributionPercentage = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage;
              this.SUKVolumeDistrubutionList[i].Customersitecode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].customersitecode;
              var volQuantity = parseFloat(this.volumeQuantity) + parseFloat(resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage);

              this.volumeQuantity = volQuantity;
            }
          }

          ////////////////////////////////////--------------------Contract--------------------------/////////
          if (resultJSON.customerSiteContractDetail != null) {
            if (resultJSON.customerSiteContractDetail.contracttypescode != null) {
              var splitContractTypes = resultJSON.customerSiteContractDetail.contracttypescode.split(',');
              var ContractTypesCode: string[] = [];
              Object.keys(splitContractTypes).map((Index) => {
                ContractTypesCode.push(splitContractTypes[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._ContractTypes = ContractTypesCode;
            }
            if (resultJSON.customerSiteContractDetail.opentypeodastatescode != null) {
              var splitState = resultJSON.customerSiteContractDetail.opentypeodastatescode.split(',');
              var StateCode: string[] = [];
              Object.keys(splitState).map((Index) => {
                StateCode.push(splitState[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._StateNG = StateCode;
            }

            for (var i = 0; i < splitContractTypes.length; i++) {
              if (splitContractTypes[i] == 'MSC00081') {
                this.HideGeneralRate = true
              }
              if (splitContractTypes[i] == 'MSC00083') {
                this.HideArticleBased = true
              }
              if (splitContractTypes[i] == 'MSC00082') {
                this.HideRegionLevel = true
              }
              if (splitContractTypes[i] == 'MSC00084') {
                this.HideSlab = true
              }
              if (splitContractTypes[i] == 'MSC00104') {
                this.Hide2DRate = true
              }
            }
            this._contracttypescode = resultJSON.customerSiteContractDetail.contracttypescode;
            this._contracttypes_ = resultJSON.customerSiteContractDetail.contracttypescode;
            // console.log(this._contracttypes_);
            this._StateCode = resultJSON.customerSiteContractDetail.opentypeodastatescode;
            this._CostingContract.controls['billingbranchcode'].setValue(resultJSON.customerSiteContractDetail.billingbranchcode);
            this._CostingContract.controls['fuelpriceperltr'].setValue(resultJSON.customerSiteContractDetail.fuelpriceperltr);
            this._CostingContract.controls['quotedrateperqtlperkm'].setValue(resultJSON.customerSiteContractDetail.quotedrateperqtlperkm);
            this._CostingContract.controls['minimumfreight'].setValue(resultJSON.customerSiteContractDetail.minimumfreight);
            this._CostingContract.controls['minimumchargeableweight'].setValue(resultJSON.customerSiteContractDetail.minimumchargeableweight);
            this._CostingContract.controls['minimumvsc'].setValue(resultJSON.customerSiteContractDetail.minimumvsc);
            this._CostingContract.controls['expectedsales'].setValue(resultJSON.customerSiteContractDetail.expectedsales);
            this._CostingContract.controls['creditlimit'].setValue(resultJSON.customerSiteContractDetail.creditlimit);
            this._CostingContract.controls['invoicecreditdays'].setValue(resultJSON.customerSiteContractDetail.invoicecreditdays);
            this._CostingContract.controls['minimumdc'].setValue(resultJSON.customerSiteContractDetail.minimumdc);
            this._CostingContract.controls['costtocompanydc'].setValue(resultJSON.customerSiteContractDetail.costtocompanydc);
            this._CostingContract.controls['costtoagentdc'].setValue(resultJSON.customerSiteContractDetail.costtoagentdc);
            this._CostingContract.controls['minimumdd'].setValue(resultJSON.customerSiteContractDetail.minimumdd);
            this._CostingContract.controls['minarticledd'].setValue(resultJSON.customerSiteContractDetail.minarticledd);
            this._CostingContract.controls['costtoagentdd'].setValue(resultJSON.customerSiteContractDetail.costtoagentdd);
            this._CostingContract.controls['minimumac'].setValue(resultJSON.customerSiteContractDetail.minimumac);
            this._CostingContract.controls['costtocompanyac'].setValue(resultJSON.customerSiteContractDetail.costtocompanyac);
            this._CostingContract.controls['costtoagentac'].setValue(resultJSON.customerSiteContractDetail.costtoagentac);
            this._CostingContract.controls['odainclusiveorexclusivecode'].setValue(resultJSON.customerSiteContractDetail.odainclusiveorexclusivecode);
            this._CostingContract.controls['costtocompanyoda'].setValue(resultJSON.customerSiteContractDetail.costtocompanyoda);
            this._CostingContract.controls['costtoagentoda'].setValue(resultJSON.customerSiteContractDetail.costtoagentoda);
            this._CostingContract.controls['flatodabasedoncode'].setValue(resultJSON.customerSiteContractDetail.flatodabasedoncode);
            this._CostingContract.controls['odachargesagreedcode'].setValue(resultJSON.customerSiteContractDetail.odachargesagreedcode);
            this._CostingContract.controls['loadingchargesbyagent'].setValue(resultJSON.customerSiteContractDetail.loadingchargesbyagent);
            this._CostingContract.controls['loadingchargesbycustomer'].setValue(resultJSON.customerSiteContractDetail.loadingchargesbycustomer);
            // this._CostingContract.controls['quotestatus'].setValue(resultJSON.customerSiteContractDetail.quotestatus);
            // if(resultJSON.customerSiteContractDetail.quotestatus == "PQT00057")
            // {
            //   this.DisableMail = true;
            // }
            // else{
            //   this.DisableMail = false;
            // }
            if (resultJSON.lstGeneralContract.length > 0) {
              this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
              this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
            }
            else{
              this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(0);
            }
            this._CostingContract.controls['odachargetypecode'].setValue(resultJSON.customerSiteContractDetail.odachargetypecode);
            this._CostingContract.controls['flatodabasedoncode'].setValue(resultJSON.customerSiteContractDetail.flatodabasedoncode);
            this._CostingContract.controls['minimumoda'].setValue(resultJSON.customerSiteContractDetail.minimumoda);
            this._CostingContract.controls['costtocompanydd'].setValue(resultJSON.customerSiteContractDetail.costtocompanydd);


            var ODAmapping = resultJSON.customerSiteContractDetail.odachargetypecode
            this.CommunicationMail = resultJSON.customerSiteContractDetail.communicationmaildocumentURL
            // console.log("oda", ODAmapping)
            if (ODAmapping == "MSC00801") {
              this.HideOpenTYpe = false
              this.HideFlatTYpe = true
              this.HideServiceable = true
              this.HideTranscationTYpe = true

            }
            if (ODAmapping == "MSC00802") {
              this.HideOpenTYpe = true
              this.HideFlatTYpe = false
              this.HideServiceable = true
              this.HideTranscationTYpe = true

            }
            if (ODAmapping == "MSC00803") {
              this.HideServiceable = false
              this.HideOpenTYpe = true
              this.HideFlatTYpe = true
              this.HideTranscationTYpe = true

            }
            if (ODAmapping == "MSC00804") {
              this.HideServiceable = false
              this.HideOpenTYpe = true
              this.HideFlatTYpe = true
              this.HideTranscationTYpe = true
            }
            if (ODAmapping == "MSC00807") {
              this.HideTranscationTYpe = false
              this.HideServiceable = true
              this.HideOpenTYpe = true
              this.HideFlatTYpe = true

            }
            var flatOda = resultJSON.customerSiteContractDetail.flatodabasedoncode
            if (flatOda == "MSC00805") {
              this.HideArticleODA = false
              this.HideTonnageODA = true
            }
            if (flatOda == "MSC00806") {
              this.HideTonnageODA = false
              this.HideArticleODA = true
            }
            if (resultJSON.lstGeneralContract.length > 0) {
              this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
              this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
            }
            if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00805') {
              this._ArticleList = resultJSON.lstFlatODACharges;
              if (resultJSON.lstFlatODACharges != null) {
                for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                  this._ArticleList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                  this._ArticleList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                  this._ArticleList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                  this._ArticleList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
                }
              }
            }
            else if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00806') {
              this._KGList = resultJSON.lstFlatODACharges;
              if (resultJSON.lstFlatODACharges != null) {
                for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                  this._KGList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                  this._KGList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                  this._KGList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                  this._KGList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
                }
              }
            }
            this._RegionList = resultJSON.lstRegionContract;
            if (resultJSON.lstRegionContract != null) {
              for (var i = 0; i < resultJSON.lstRegionContract.length; i++) {
                this._RegionList[i].customersitecode = resultJSON.lstRegionContract[i].customersitecode;
                this._RegionList[i].frombranchcode = resultJSON.lstRegionContract[i].frombranchcode;
                this._RegionList[i].frombranch = resultJSON.lstRegionContract[i].frombranch;
                this._RegionList[i].toregioncode = resultJSON.lstRegionContract[i].toregioncode;
                this._RegionList[i].toregion = resultJSON.lstRegionContract[i].toregion;
                this._RegionList[i].articlecode = resultJSON.lstRegionContract[i].articlecode;
                this._RegionList[i].article = resultJSON.lstRegionContract[i].article;
                this._RegionList[i].ratetypecode = resultJSON.lstRegionContract[i].ratetypecode;
                this._RegionList[i].ratetype = resultJSON.lstRegionContract[i].ratetype;
                this._RegionList[i].rate = resultJSON.lstRegionContract[i].rate;
                this._RegionList[i].dcratetypecode = resultJSON.lstRegionContract[i].dcratetypecode;
                this._RegionList[i].dcratetype = resultJSON.lstRegionContract[i].dcratetype;
                this._RegionList[i].dcrate = resultJSON.lstRegionContract[i].dcrate;
                this._RegionList[i].ddratetypecode = resultJSON.lstRegionContract[i].ddratetypecode;
                this._RegionList[i].ddratetype = resultJSON.lstRegionContract[i].ddratetype;
                this._RegionList[i].ddrate = resultJSON.lstRegionContract[i].ddrate;
                this._RegionList[i].acratetypecode = resultJSON.lstRegionContract[i].acratetypecode;
                this._RegionList[i].acratetype = resultJSON.lstRegionContract[i].acratetype;
                this._RegionList[i].acrate = resultJSON.lstRegionContract[i].acrate;
                this._RegionList[i].inclusiveorexclusivecode = resultJSON.lstRegionContract[i].inclusiveorexclusivecode;
                this._RegionList[i].inclusiveorexclusive = resultJSON.lstRegionContract[i].inclusiveorexclusive;
                this._RegionList[i].isneedreversebooking = resultJSON.lstRegionContract[i].isneedreversebooking;
                this._RegionList[i].isneedreversebookingcode = resultJSON.lstRegionContract[i].isneedreversebookingcode;
                this._RegionList[i].lstDCDDACSlabs = resultJSON.lstRegionContract[i].lstDCDDACSlabs;
                if (resultJSON.lstRegionContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstRegionContract[i].lstDCDDACSlabs.length; j++) {
                    this._RegionList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._RegionList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._RegionList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._RegionList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._RegionList[i].lstDCDDACSlabs.slabto = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabto;
                    this._RegionList[i].lstDCDDACSlabs.slabrate = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
              }
            }
            // console.log(this._RegionList);
            this._ArticleBasedList = resultJSON.lstArticleContract;
            if (resultJSON.lstArticleContract != null) {
              for (var i = 0; i < resultJSON.lstArticleContract.length; i++) {
                this._ArticleBasedList[i].customersitecode = resultJSON.lstArticleContract[i].customersitecode;
                this._ArticleBasedList[i].frombranchcode = resultJSON.lstArticleContract[i].frombranchcode;
                this._ArticleBasedList[i].frombranch = resultJSON.lstArticleContract[i].frombranch;
                this._ArticleBasedList[i].tobranchcode = resultJSON.lstArticleContract[i].tobranchcode;
                this._ArticleBasedList[i].tobranch = resultJSON.lstArticleContract[i].tobranch;
                this._ArticleBasedList[i].articlecode = resultJSON.lstArticleContract[i].articlecode;
                this._ArticleBasedList[i].article = resultJSON.lstArticleContract[i].article;
                this._ArticleBasedList[i].ratetypecode = resultJSON.lstArticleContract[i].ratetypecode;
                this._ArticleBasedList[i].ratetype = resultJSON.lstArticleContract[i].ratetype;
                this._ArticleBasedList[i].rate = resultJSON.lstArticleContract[i].rate;
                this._ArticleBasedList[i].discount = resultJSON.lstArticleContract[i].discount;
                this._ArticleBasedList[i].finalrate = resultJSON.lstArticleContract[i].finalrate;
                this._ArticleBasedList[i].dcratetypecode = resultJSON.lstArticleContract[i].dcratetypecode;
                this._ArticleBasedList[i].dcratetype = resultJSON.lstArticleContract[i].dcratetype;
                this._ArticleBasedList[i].dcrate = resultJSON.lstArticleContract[i].dcrate;
                this._ArticleBasedList[i].ddratetypecode = resultJSON.lstArticleContract[i].ddratetypecode;
                this._ArticleBasedList[i].ddratetype = resultJSON.lstArticleContract[i].ddratetype;
                this._ArticleBasedList[i].ddrate = resultJSON.lstArticleContract[i].ddrate;
                this._ArticleBasedList[i].acratetypecode = resultJSON.lstArticleContract[i].acratetypecode;
                this._ArticleBasedList[i].acratetype = resultJSON.lstArticleContract[i].acratetype;
                this._ArticleBasedList[i].acrate = resultJSON.lstArticleContract[i].acrate;
                this._ArticleBasedList[i].inclusiveorexclusivecode = resultJSON.lstArticleContract[i].inclusiveorexclusivecode;
                this._ArticleBasedList[i].inclusiveorexclusive = resultJSON.lstArticleContract[i].inclusiveorexclusive;
                this._ArticleBasedList[i].isneedreversebooking = resultJSON.lstArticleContract[i].isneedreversebooking;
                this._ArticleBasedList[i].isneedreversebookingcode = resultJSON.lstArticleContract[i].isneedreversebookingcode;
                this._ArticleBasedList[i].lstDCDDACSlabs = resultJSON.lstArticleContract[i].lstDCDDACSlabs;
                if (resultJSON.lstArticleContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstArticleContract[i].lstDCDDACSlabs.length; j++) {
                    this._ArticleBasedList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabto = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabto;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabrate = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
              }
            }
            if (resultJSON.lstSlabContract != null) {
              this._SlabFormList = resultJSON.lstSlabContract;
              for (var i = 0; i < resultJSON.lstSlabContract.length; i++) {
                this._SlabFormList[i].customersitecode = resultJSON.lstSlabContract[i].customersitecode;
                this._SlabFormList[i].frombranchcode = resultJSON.lstSlabContract[i].frombranchcode;
                this._SlabFormList[i].frombranch = resultJSON.lstSlabContract[i].frombranch;
                this._SlabFormList[i].tobranchcode = resultJSON.lstSlabContract[i].tobranchcode;
                this._SlabFormList[i].tobranch = resultJSON.lstSlabContract[i].tobranch;
                this._SlabFormList[i].articlecode = resultJSON.lstSlabContract[i].articlecode;
                this._SlabFormList[i].article = resultJSON.lstSlabContract[i].article;
                this._SlabFormList[i].ratetypecode = resultJSON.lstSlabContract[i].ratetypecode;
                this._SlabFormList[i].ratetype = resultJSON.lstSlabContract[i].ratetype;
                this._SlabFormList[i].rate = resultJSON.lstSlabContract[i].rate;
                this._SlabFormList[i].dcratetypecode = resultJSON.lstSlabContract[i].dcratetypecode;
                this._SlabFormList[i].dcratetype = resultJSON.lstSlabContract[i].dcratetype;
                this._SlabFormList[i].dcrate = resultJSON.lstSlabContract[i].dcrate;
                this._SlabFormList[i].ddratetypecode = resultJSON.lstSlabContract[i].ddratetypecode;
                this._SlabFormList[i].ddratetype = resultJSON.lstSlabContract[i].ddratetype;
                this._SlabFormList[i].ddrate = resultJSON.lstSlabContract[i].ddrate;
                this._SlabFormList[i].acratetypecode = resultJSON.lstSlabContract[i].acratetypecode;
                this._SlabFormList[i].acratetype = resultJSON.lstSlabContract[i].acratetype;
                this._SlabFormList[i].acrate = resultJSON.lstSlabContract[i].acrate;
                this._SlabFormList[i].inclusiveorexclusivecode = resultJSON.lstSlabContract[i].inclusiveorexclusivecode;
                this._SlabFormList[i].inclusiveorexclusive = resultJSON.lstSlabContract[i].inclusiveorexclusive;
                this._SlabFormList[i].isneedreversebooking = resultJSON.lstSlabContract[i].isneedreversebooking;
                this._SlabFormList[i].isneedreversebookingcode = resultJSON.lstSlabContract[i].isneedreversebookingcode;
                this._SlabFormList[i].lstDCDDACSlabs = resultJSON.lstSlabContract[i].lstDCDDACSlabs;
                if (resultJSON.lstSlabContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstSlabContract[i].lstDCDDACSlabs.length; j++) {
                    this._SlabFormList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._SlabFormList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._SlabFormList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._SlabFormList[i].lstDCDDACSlabs.slabto = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabto;
                    this._SlabFormList[i].lstDCDDACSlabs.slabrate = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
                if (resultJSON.lstSlabContract[i].lstRateSlabs != null) {
                  for (var j = 0; j < resultJSON.lstSlabContract[i].lstRateSlabs.length; j++) {
                    this._SlabFormList[i].lstRateSlabs.customersitecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].customersitecode;
                    this._SlabFormList[i].lstRateSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstRateSlabs.contracttype = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstRateSlabs.slabfrom = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabfrom;
                    this._SlabFormList[i].lstRateSlabs.slabto = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabto;
                    this._SlabFormList[i].lstRateSlabs.slabrate = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabrate;
                  }
                }
              }
            }
            if (resultJSON.lstTwoDContract != null) {
              this._2DList = resultJSON.lstTwoDContract;
              for (var i = 0; i < resultJSON.lstTwoDContract.length; i++) {
                this._2DList[i].customersitecode = resultJSON.lstTwoDContract[i].customersitecode;
                this._2DList[i].frombranchcode = resultJSON.lstTwoDContract[i].frombranchcode;
                this._2DList[i].frombranch = resultJSON.lstTwoDContract[i].frombranch;
                this._2DList[i].toKM = resultJSON.lstTwoDContract[i].toKM;
                this._2DList[i].articlecode = resultJSON.lstTwoDContract[i].articlecode;
                this._2DList[i].article = resultJSON.lstTwoDContract[i].article;
                this._2DList[i].ratetypecode = resultJSON.lstTwoDContract[i].ratetypecode;
                this._2DList[i].ratetype = resultJSON.lstTwoDContract[i].ratetype;
                this._2DList[i].rate = resultJSON.lstTwoDContract[i].rate;
                this._2DList[i].dcratetypecode = resultJSON.lstTwoDContract[i].dcratetypecode;
                this._2DList[i].dcratetype = resultJSON.lstTwoDContract[i].dcratetype;
                this._2DList[i].dcrate = resultJSON.lstTwoDContract[i].dcrate;
                this._2DList[i].ddratetypecode = resultJSON.lstTwoDContract[i].ddratetypecode;
                this._2DList[i].ddratetype = resultJSON.lstTwoDContract[i].ddratetype;
                this._2DList[i].ddrate = resultJSON.lstTwoDContract[i].ddrate;
                this._2DList[i].acratetypecode = resultJSON.lstTwoDContract[i].acratetypecode;
                this._2DList[i].acratetype = resultJSON.lstTwoDContract[i].acratetype;
                this._2DList[i].acrate = resultJSON.lstTwoDContract[i].acrate;
                this._2DList[i].inclusiveorexclusivecode = resultJSON.lstTwoDContract[i].inclusiveorexclusivecode;
                this._2DList[i].inclusiveorexclusive = resultJSON.lstTwoDContract[i].inclusiveorexclusive;
                this._2DList[i].isneedreversebooking = resultJSON.lstTwoDContract[i].isneedreversebooking;
                this._2DList[i].isneedreversebookingcode = resultJSON.lstTwoDContract[i].isneedreversebookingcode;
                this._2DList[i].lstDCDDACSlabs = resultJSON.lstTwoDContract[i].lstDCDDACSlabs;
                if (resultJSON.lstTwoDContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstTwoDContract[i].lstDCDDACSlabs.length; j++) {
                    this._2DList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._2DList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._2DList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._2DList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._2DList[i].lstDCDDACSlabs.slabto = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabto;
                    this._2DList[i].lstDCDDACSlabs.slabrate = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
                if (resultJSON.lstTwoDContract[i].lstRateSlabs != null) {
                  for (var j = 0; j < resultJSON.lstTwoDContract[i].lstRateSlabs.length; j++) {
                    this._2DList[i].lstRateSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstRateSlabs[j].customersitecode;
                    this._2DList[i].lstRateSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstRateSlabs[j].contracttypecode;
                    this._2DList[i].lstRateSlabs.contracttype = resultJSON.lstTwoDContract[i].lstRateSlabs[j].contracttypecode;
                    this._2DList[i].lstRateSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabfrom;
                    this._2DList[i].lstRateSlabs.slabto = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabto;
                    this._2DList[i].lstRateSlabs.slabrate = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabrate;
                  }
                }
              }
            }

            if (resultJSON.lstAddOnCharge != null) {
              this.WayBillList = resultJSON.lstAddOnCharge;
              for (var i = 0; i < resultJSON.lstAddOnCharge.length; i++) {
                this.WayBillList[i].customersitecode = resultJSON.lstAddOnCharge[i].customersitecode;
                this.WayBillList[i].chargetypecode = resultJSON.lstAddOnCharge[i].chargetypecode;
                this.WayBillList[i].chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargetypecode)[0].chargeName;
                this.WayBillList[i].chargeratetypecode = resultJSON.lstAddOnCharge[i].chargeratetypecode;
                this.WayBillList[i].chargeratetype = resultJSON.lstAddOnCharge[i].chargeratetype;
                this.WayBillList[i].chargecodeid = resultJSON.lstAddOnCharge[i].chargecodeid;
                //this.WayBillList[i].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargecodeid)[0].chargeName;
                this.WayBillList[i].rate = resultJSON.lstAddOnCharge[i].rate;
                this.WayBillList[i].inclusiveorexclusivecode = resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode;
                this.WayBillList[i].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode)[0].metasubdescription;
                this.WayBillList[i].printinothercharge = resultJSON.lstAddOnCharge[i].printinothercharge;
                this.WayBillList[i].lstAddOnSlabs = resultJSON.lstAddOnCharge[i].lstAddOnSlabs;
                if (resultJSON.lstAddOnCharge[i].lstAddOnSlabs != null) {
                  for (var j = 0; j < resultJSON.lstAddOnCharge[i].lstAddOnSlabs.length; j++) {
                    this.WayBillList[i].lstAddOnSlabs.customersitecode = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].customersitecode;
                    this.WayBillList[i].lstAddOnSlabs.slabfrom = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabfrom;
                    this.WayBillList[i].lstAddOnSlabs.slabto = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabto;
                    this.WayBillList[i].lstAddOnSlabs.slabrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabrate;
                    this.WayBillList[i].lstAddOnSlabs.slabaddrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabaddrate;
                    this.WayBillList[i].lstAddOnSlabs.chargecodeid = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Chargecodeid;
                  }
                }
              }
            }
            
          }



          ///////////////////////////////////------------------------Existing Vendor-------------------------/////////
          if (resultJSON.lstCustomerSiteVendor != null) {
            this.ExistingVendorList = resultJSON.lstCustomerSiteVendor
            for (var i = 0; i < resultJSON.lstCustomerSiteVendor.length; i++) {
              this.ExistingVendorList[i].vendorId = resultJSON.lstCustomerSiteVendor[i].vendorId;
              this.ExistingVendorList[i].vendorName = resultJSON.lstCustomerSiteVendor[i].vendorName;
              this.ExistingVendorList[i].vendorRates = resultJSON.lstCustomerSiteVendor[i].vendorRates;
              this.ExistingVendorList[i].vendorStrength = resultJSON.lstCustomerSiteVendor[i].vendorStrength;
              this.ExistingVendorList[i].vendorPainPoint = resultJSON.lstCustomerSiteVendor[i].vendorPainPoint;
            }
          }

          ///////////////////////////////////----------------------------Trade Reference-----------------------------/////////
          if (resultJSON.lstCSTradeReferenceInside != null) {
            this.TempWithinCompanyList = resultJSON.lstCSTradeReferenceInside
            this.WithinCompanyList = resultJSON.lstCSTradeReferenceInside
            for (var i = 0; i < resultJSON.lstCSTradeReferenceInside.length; i++) {
              this.WithinCompanyList[i].tradeReferenceId = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
              this.WithinCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceTypeCode;
              this.WithinCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceType;
              this.WithinCompanyList[i].personName = resultJSON.lstCSTradeReferenceInside[i].personName;
              this.WithinCompanyList[i].designation = resultJSON.lstCSTradeReferenceInside[i].designation;
              this.WithinCompanyList[i].emailId = resultJSON.lstCSTradeReferenceInside[i].emailId;
              this.WithinCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceInside[i].phoneNo;
              this.WithinCompanyList[i].remarks = resultJSON.lstCSTradeReferenceInside[i].remarks;
            }
          }
          if (resultJSON.lstCSTradeReferenceInside != null) {

            this.TempoutsideCompanyList = resultJSON.lstCSTradeReferenceOutside
            this.outsideCompanyList = resultJSON.lstCSTradeReferenceOutside

            for (var i = 0; i < resultJSON.lstCSTradeReferenceOutside.length; i++) {
              this.outsideCompanyList[i].tradeReferenceId = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceId;
              this.outsideCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceTypeCode;
              this.outsideCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceType;
              this.outsideCompanyList[i].personName = resultJSON.lstCSTradeReferenceOutside[i].personName;
              this.outsideCompanyList[i].designation = resultJSON.lstCSTradeReferenceOutside[i].designation;
              this.outsideCompanyList[i].emailId = resultJSON.lstCSTradeReferenceOutside[i].emailId;
              this.outsideCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceOutside[i].phoneNo;
              this.outsideCompanyList[i].remarks = resultJSON.lstCSTradeReferenceOutside[i].remarks;
            }

          }

          if (resultJSON.lstApprovalComment != null) {

            this._ApprovalComment = resultJSON.lstApprovalComment;

            for (var i = 0; i < resultJSON.lstApprovalComment.length; i++) {
              this._ApprovalComment[i].approvalComments = resultJSON.lstApprovalComment[i].approvalComments;
              this._ApprovalComment[i].approverRoleName = resultJSON.lstApprovalComment[i].approverRoleName;    
              this._ApprovalComment[i].approverUserName = resultJSON.lstApprovalComment[i].approverUserName;            
            }

          }

          this._CostingContract.disable();
          this._ServiceLocationAndOperation_Form.disable();
          this._CustomerSiteform.disable();
          this._CustomerAddressPickupform.disable();
          this._CustomerAddressBillingform.disable();
          this._CustomerContactPickform.disable();
          this._CustomerSiteContractGeneralForm.disable();

        }
        else {
          this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._CustomExceptionService.handleError(error) });
    }
  }

  OpenCustomerImageGST() {
    if (this._LastAddedGSTDocumentinCustomer != null) {
      var signoffimage = URL.createObjectURL(this._LastAddedGSTDocumentinCustomer)
      window.open(signoffimage, "_blank");
    }
    else if (this.GSTimageselect != null) {
      window.open(this._Url + "/UploadedFiles/" + this.GSTimageselect, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Please select image");
    }


  }
  map() {
    this.displayMap = true;
    this.setCurrentPosition();

  } 
  OpenCustomerImage() {
    // if (this._LastAddedDocumentinCustomer != null) {
    //   var signoffimage = URL.createObjectURL(this._LastAddedDocumentinCustomer)
    //   window.open(signoffimage, "_blank");
    // }
    // else {
    if (this.imageselect != null || this.imageselect != undefined) {
      window.open(this._Url + "/UploadedFiles/" + this.imageselect, "_blank");
    }
  }
  showBasicDialogValue() {
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00635') {
      this.displayPieceWayBill = true;
    }
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00634') {
      this.displayKGWayBill = true;
    }
  }
}
  


